import Vue from 'vue';
import App from './App';
import routes from './router';
import Router from 'vue-router';
import {get,post} from '../store/vue_resource';
import {hasBtn,getBtnStatus,removeByIndex,getTime} from '../store/store';

import JsonExcel from 'vue-json-excel';
Vue.component('downloadExcel', JsonExcel);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/style.css';
import './assets/font_css/iconfont.css';
import GeminiScrollbar from 'vue-gemini-scrollbar';
import VueResource from 'vue-resource';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$getBtnStatus = getBtnStatus;
Vue.prototype.hasBtn = hasBtn;
Vue.prototype.removeByIndex = removeByIndex;
Vue.prototype.getTime = getTime;
Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(GeminiScrollbar);
Vue.use(VueResource);
Vue.component(CollapseTransition.name, CollapseTransition);



const router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
	if (to.path == '/login') {
		sessionStorage.removeItem('TokenId');
	};
	let token = sessionStorage.getItem('TokenId');
	if (!token && to.path != '/login') {
		next({
			path: '/login'
		})
	} else if (to.path == '/') {
		next({
			path: 'list_index'
		})
	} else {
		next()
	}
})


new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js